import { useConnection } from "../../stores/connectionStore";

/**
 * Design: Connection / Reconnecting. Tiny, isolated re-render.
 * Shows only "Reconnecting…" (a live connection dropped). Connected, connecting and the first-paint snapshot say
 * nothing visible (the "Snapshot · <time>" chip was removed on request, 2026-10-14). A meeting in session shows its
 * own LIVE chip; that's about the meeting, not the socket.
 */
export function ConnectionStatus() {
  const status = useConnection((s) => s.status);
  if (status !== "reconnecting") return <span className="sr-only" role="status">{status === "live" ? "Connected" : ""}</span>;
  return (
    <span className="conn" data-status={status} role="status">
      <i className="dot" />Reconnecting…
    </span>
  );
}
